// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-box-container[data-v-17ebb34f] .v-input__slot{padding-left:8px;color:#545454;font-size:14px;letter-spacing:.53px}", ""]);
// Exports
module.exports = exports;
